import React, { useState, useRef } from 'react'
import Swiper from 'react-id-swiper'
import 'swiper/swiper.scss'

import ButtonCarousel from './../ButtonCarousel'

import styles from './styles.module.scss'

const Carousel = ({ params, children, style = 'light', className }) => {
	
	const swiperRef = useRef(null)
	
	const goNext = () => {
		if (swiperRef.current && swiperRef.current.swiper) {
			swiperRef.current.swiper.slideNext()
      	}
    }
	
	const goPrev = () => {
		if (swiperRef.current && swiperRef.current.swiper) {
			swiperRef.current.swiper.slidePrev()
		}
	}

	return (
		<div className={`${styles['carousel']} ${className || ''}`}>
			<Swiper ref={swiperRef} {...params}>
				{children}
			</Swiper>
			<ButtonCarousel className={styles['carousel__button']} onClick={goPrev} />
			<ButtonCarousel className={styles['carousel__button']} onClick={goNext} />
		</div>
	)
}

export default Carousel
